import React from 'react';
import { NavLink } from 'react-router-dom';
import { Flame, Search, Map, MessageCircle, User, Briefcase, Users, Plus } from 'lucide-react';
import { useApp } from '../context/AppContext';
import './DesktopSidebar.css';

const linkClass = ({ isActive }) =>
  `d-sidebar__link${isActive ? ' d-sidebar__link--active' : ''}`;

export default function DesktopSidebar() {
  const { userType, notifications } = useApp();
  const isEmployer = userType === 'employer';

  return (
    <aside className="d-sidebar">
      {isEmployer ? (
        <>
          <div className="d-sidebar__section">Arbeitgeber</div>

          <NavLink to="/" end className={linkClass}>
            <Briefcase size={20} />
            <span>Inserate</span>
          </NavLink>

          <NavLink to="/talents" className={linkClass}>
            <Users size={20} />
            <span>Talente</span>
          </NavLink>

          <NavLink to="/chat" className={linkClass}>
            <MessageCircle size={20} />
            <span>Chat</span>
            {notifications > 0 && <span className="d-sidebar__badge" />}
          </NavLink>

          <NavLink to="/profile" className={linkClass}>
            <User size={20} />
            <span>Profil</span>
          </NavLink>

          <div className="d-sidebar__cta">
            <NavLink to="/post-job" className="d-sidebar__cta-btn">
              <Plus size={18} />
              <span>Inserat erstellen</span>
            </NavLink>
          </div>
        </>
      ) : (
        <>
          <div className="d-sidebar__section">Entdecken</div>

          <NavLink to="/" end className={linkClass}>
            <Flame size={20} />
            <span>Vorschläge</span>
          </NavLink>

          <NavLink to="/search" className={linkClass}>
            <Search size={20} />
            <span>Suchen</span>
          </NavLink>

          <NavLink to="/map" className={linkClass}>
            <Map size={20} />
            <span>Karte</span>
          </NavLink>

          <NavLink to="/chat" className={linkClass}>
            <MessageCircle size={20} />
            <span>Chat</span>
            {notifications > 0 && <span className="d-sidebar__badge" />}
          </NavLink>

          <NavLink to="/profile" className={linkClass}>
            <User size={20} />
            <span>Profil</span>
          </NavLink>

          <div className="d-sidebar__cta">
            <NavLink to="/" className="d-sidebar__cta-btn">
              <Flame size={18} />
              <span>Job finden</span>
            </NavLink>
          </div>
        </>
      )}
    </aside>
  );
}
